/// <amd-module name="typeahead/features/IncreaseMobileFontSize" />
/// <amd-dependency path="jquery" name="$"/>

import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const emptyString = "";
const fontSizeProperty = "font-size:";
const fontSizeUnit = "em";

const largeFontBoost = "1.077";
const largerFontBoost = "1.154";
const largestFontBoost = "1.231";

const largeConfig: IStripingConfiguration[] = [
    {
        experiment: {
            id: 14895,
            name: "IncreaseFontSizeFlights",
            value: 1,
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 14896,
            name: "IncreaseFontSizeHotels",
            value: 1,
        },
        tabs: ["hotel"],
    },
];

const largerConfig: IStripingConfiguration[] = [
    {
        experiment: {
            id: 14895,
            name: "IncreaseFontSizeFlights",
            value: 2,
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 14896,
            name: "IncreaseFontSizeHotels",
            value: 2,
        },
        tabs: ["hotel"],
    },
];

const largestConfig: IStripingConfiguration[] = [
    {
        experiment: {
            id: 14895,
            name: "IncreaseFontSizeFlights",
            value: 3,
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 14896,
            name: "IncreaseFontSizeHotels",
            value: 3,
        },
       tabs: ["hotel"],
    },
    {
      tabs: ["car"],
    },
];
const allConfigs = [largeConfig, largerConfig, largestConfig];

export class IncreaseMobileFontSize implements IExperimentalFeature, ISuggestionsModifier {
    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments([].concat.apply([], allConfigs));
    }
    public modifySuggestions(suggestions: any, context: IContext, options: any): JQueryPromise<Object[]> {
        let fontSizeBoost = emptyString;
        let deferred: JQueryDeferred<Object[]> = $.Deferred();
        if (TypeaheadUtils.isWithinMobileBreakpoint()
            && suggestions && suggestions.length > 0) {

            ExecutionHelper.shouldExecute(context, largeConfig)
                .done((largeFontSize) => {
                if (largeFontSize) {
                    fontSizeBoost = largeFontBoost;
                }
            });
            ExecutionHelper.shouldExecute(context, largerConfig)
                .done((largerFontSize) => {
                if (largerFontSize) {
                    fontSizeBoost = largerFontBoost;
                }
            });
            ExecutionHelper.shouldExecute(context, largestConfig)
                .done((largestFontSize) => {
                if (largestFontSize) {
                    fontSizeBoost = largestFontBoost;
                }
            });

            if (fontSizeBoost !== emptyString) {
                suggestions.forEach((sr): void => {
                    sr.style = `${fontSizeProperty}${fontSizeBoost}${fontSizeUnit}`;
                });
            }
        }
        deferred.resolve(suggestions);
        return deferred.promise();
    }
}
